import { ChangeBoarding } from './change-boarding';

export {
	CoordinationStopProvider,
	CONTEXT_GROUP_CHANGE_BOARDING_MESSAGE_ID,
} from './change-boarding';

export default ChangeBoarding;
